export class CompleteApplicationData{
    WSCallUserFirstName: any;
    WSCallUserMiddleName: any;
    WSCallUserLastName: any;
    WSCallUserGender: any;
    WSCallUserCity: any;
    WSCallUserEmailId: any;​
    WSCallUserMobileNumber: any;​
    WSCallCardType: any;
    WSCallCardCategory: any;
    WSCallUserSalutation: any;
    WSCallUserConsent: any;
    WSCallUserDesignation: any;
    WSCallUserCompany: any;
    WSCallUserOfficePincode: any;​
    WSCallUserHouseNo: any;
    WSCallUserLocality: any;​
    WSCallUserResiPincode: any;
    WSCallUserCouponCode: any;
    WSCallDomainName: any;​
    WSCallIpaddress: any;
    WSCallHostname: any;
    WSCallUserResiStatus: any;​
    WSCallUserYearsAtCurrentResi: any;
    WSCallUserFathersName: any;
    WSCallUserMothersName: any;
    WSCallUserPreferredMailAddress: any;
    WSCallUserFeeCode: any;
    WSCallUserAmaId: any;
    WSCallUserPermPinCode: any;
    WSCallUserApplicationNumber: any;
    WSCallUserQualification: any;​
    WSCallUserAltCardNumber: any;
    WSCallUserSbiAccountNo: any;
    WSCallUserIsPermResiAddressSame: any;
    WSCallUserPerHouseNo: any;
    WSCallUserPerLocality: any;
    WSCallUserPerAddLine: any;​
    WSCallUserOfficialEmailId: any;
    WSCallUserOffPhone: any;
    WSCallBusinessType: any;
    WSCallUserOffAddLine1: any;
    WSCallUserOffAddLine2: any;
    WSCallUserOffLandmark: any;
    WSCallUserFrequentFlyer: any;
    WSCallUserCkycNumber: any;
    WSCallUserCppConsent: any;
    WSCallContactlessDomestic:string;
    WSCallContactlessInternational:string;
    WSCallDomesticOnline:string;
    WSCallInternationalOnline:string;
    WSCallPosInternational:string;
    WSCallOnlinePosAtmConsent:string;
    WSCallUserAnnualIncomeValue:any;

    
}​